import { render, staticRenderFns } from "./PortesEmpresasEditar.vue?vue&type=template&id=e4d6a412&scoped=true&"
import script from "./PortesEmpresasEditar.vue?vue&type=script&lang=js&"
export * from "./PortesEmpresasEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d6a412",
  null
  
)

export default component.exports